import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  makeStyles,
  CircularProgress,
  Grid,
} from "@material-ui/core";
import moment from "moment";
import { convertToLocaleDateTime } from "../functionalComponents/FormatDateTimeToLocale";

const useStyles = makeStyles((theme) => ({
  tableHeader: {
    backgroundColor: "#f5d8c7", // Light orange color for the header
    fontWeight: "bold",
  },
  tableContainer: {
    marginTop: theme.spacing(3),
    maxHeight: 450, // Set the max height of the table container (adjust as needed)
    overflowY: "auto", // Enable vertical scrolling
  },
}));

export default function AuditTable({ poAuditTrail, error, loading }) {
  const classes = useStyles();

  return (
    <TableContainer component={Paper} className={classes.tableContainer}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell className={`${classes.tableHeader} `}>
              Date & Time
            </TableCell>
            <TableCell className={classes.tableHeader}>Event</TableCell>
            <TableCell className={classes.tableHeader}>
              Event Description
            </TableCell>
            <TableCell className={classes.tableHeader}>PO Status</TableCell>
            <TableCell className={classes.tableHeader}>Organization</TableCell>
            <TableCell className={classes.tableHeader}>Role</TableCell>
            <TableCell className={classes.tableHeader}>Username</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow style={{ height: 150 }}>
              <TableCell colSpan={12}>
                <div style={{ textAlign: "center" }}>
                  <CircularProgress color="primary" thickness={7} />
                </div>
              </TableCell>
            </TableRow>
          ) : error ? (
            <TableRow
              style={{
                border: "2px solid rgb(255,0,0)",
                backgroundColor: "rgb(255,240,240)",
                Opacity: 1,
                textAlign: "center",
                padding: "0.8rem",
                fontSize: "0.875rem",
              }}
            >
              <TableCell colSpan={8} align="center">
                Something went wrong. Please try again later.
              </TableCell>
            </TableRow>
          ) : (
            poAuditTrail?.map((row, index) => (
              <TableRow key={index}>
                <TableCell>
                  <div style={{
                    display: "flex",

                    flexDirection: "row",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                  >
                  <Grid
                    style={{
                      width: "10px",
                      height: "10px",
                      borderRadius: "50px",
                      backgroundColor: "#ec6535",
                    }}
                  ></Grid>
                  <Grid>
                    {row?.lastUpdatedDate
                      ? `${moment(convertToLocaleDateTime(row?.lastUpdatedDate)).format("DD-MMM-YYYY HH:mm:ss").toUpperCase()}`
                      : "NA"}
                  </Grid>
                  {/* <br />
                  {row?.lastUpdatedDate?.split(" ").slice(1).join(" ")} */}
                    </div>
                </TableCell>
                <TableCell>{row?.event || "NA"} </TableCell>
                <TableCell>{row?.eventDescription || "NA"}</TableCell>
                <TableCell>{row?.status || "NA"}</TableCell>
                <TableCell>{row?.organizationName || "NA"}</TableCell>
                <TableCell>{row?.role || "NA"}</TableCell>
                <TableCell>{row?.lastUpdatedBy || "NA"}</TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
